<template>
    <section>
      <el-dialog
        title="编辑智能体"
        :visible.sync="editFormVisible"
        v-model="editFormVisible"
        :close-on-click-modal="false"
        :before-close="closetc"
      >
        <el-form
          :model="editForm"
          label-width="120px"
          :rules="editFormRules"
          ref="editForm"
        >
        <el-form-item label="名称" prop="Name">
            <el-input v-model="editForm.Name" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="智能体ID" prop="BotID">
            <el-input v-model="editForm.BotID" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="应用ID" prop="AppID">
            <el-input v-model="editForm.AppID" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="公钥" prop="PublicKey">
            <el-input v-model="editForm.PublicKey" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="私钥" prop="PrivateKey">
            <el-input v-model="editForm.PrivateKey" auto-complete="off"></el-input>
          </el-form-item>
        
          <el-form-item label="开场问候语" prop="Greet">
            <el-input v-model="editForm.Greet" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="英语开场问候语" prop="Greet">
            <el-input v-model="editForm.Greet_en" auto-complete="off"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closetc">关闭</el-button>
          <el-button
            type="primary"
            @click.native="addSubmit"
            :loading="addLoading"
            >提交</el-button
          >
        </div>
      </el-dialog>
    </section>
  </template>
  
  
  
  <script>
  import { editBots, BaseApiUrl } from "../../api/api";
  export default {
    props: {
        editForm:{}
    },
    data() {
      return {
        token: {
          Authorization: "Bearer ",
        },
        fileAction: BaseApiUrl + "/images/Upload/PicOne",
        editFormVisible:true,
        options: [],
        addLoading: false,
        clinicLoading:false,
        editFormRules: {
         
        },
      };
    },
    methods: {
        
      closetc(index) { 
        this.$parent.closetc(); //将值传给父组件 
      },
      //新增
      addSubmit: function () {
        let _this = this;
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm("确认提交吗？", "提示", {}).then(() => {
              this.addLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.editForm);
              var user = JSON.parse(window.localStorage.user);
              if (user && user.uID > 0) {
              } else {
                this.$message({
                  message: "用户信息为空，先登录",
                  type: "error",
                });
                _this.$router.replace(
                  _this.$route.query.redirect ? _this.$route.query.redirect : "/"
                );
              }
              
              editBots(para).then((res) => {
                this.addLoading = false;
                if (res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  }); 
                  this.$parent.closetc(1);
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            });
          }
        });
      },
     
    },
    mounted() { 
        let tokenStr = window.localStorage.Token;
        this.token = {
            Authorization: "Bearer " + tokenStr,
        };
     

    },
  };
  </script> 